import { ReactNode, createContext, memo, useContext } from 'react';
import { BehaviorSubject } from 'rxjs';

export type QuotationSelectionContextProps = {
  selection$: BehaviorSubject<string[]>;
  addCustomQuotationSubject: (name: string) => void;
  removeQuotationSubject: (name: string) => void;
  toggleQuotationSubject: (name: string) => void;
  clearSelection: () => void;
};

export const QuotationSelectionContext =
  createContext<QuotationSelectionContextProps>(null as any);

export const useQuotationSelectionContext = () =>
  useContext(QuotationSelectionContext);

export const QuotationSelectionProvider = memo(
  ({
    children,
    ...value
  }: {
    children?: ReactNode;
    selection$: BehaviorSubject<string[]>;
    addCustomQuotationSubject: (name: string) => void;
    removeQuotationSubject: (name: string) => void;
    toggleQuotationSubject: (name: string) => void;
    clearSelection: () => void;
  }) => {
    return (
      <QuotationSelectionContext.Provider value={value}>
        {children}
      </QuotationSelectionContext.Provider>
    );
  },
);
